const theme = {
  colors: {},
  fonts: [
    'sans-serif',
    'Roboto',
    'Noto Sans',
    'Noto Sans Condensed',
    'Noto Sans Semi Condensed',
  ],
  fontSizes: {},
};

export { theme };
